module.exports = __webpack_public_path__ + "static/media/bg.6508b6f0.png";